import React from 'react';
import { motion, AnimatePresence, Variants } from 'framer-motion';
import { CategoryFilterProps } from '../../types/category';

const buttonVariants: Variants = {
  initial: { opacity: 0, scale: 0.85, y: 10 },
  animate: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.32, ease: [0.4, 0, 0.2, 1] } },
  exit: { opacity: 0, scale: 0.85, y: -10, transition: { duration: 0.22, ease: [0.4, 0, 0.2, 1] } },
};

const rowVariants: Variants = {
  initial: { opacity: 0, height: 0, y: -16 },
  animate: {
    opacity: 1,
    height: 'auto',
    y: 0,
    transition: { duration: 0.38, ease: [0.4, 0, 0.2, 1] },
  },
  exit: { opacity: 0, height: 0, y: -16, transition: { duration: 0.38, ease: [0.4, 0, 0.2, 1] } },
};

const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categories,
  selectedCategory,
  onSelect,
  minHeight,
  animated = false,
  show = true,
}) => {
  if (animated) {
    return (
      <AnimatePresence mode="wait">
        {show && (
          <motion.div
            key="filter-row"
            variants={rowVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            style={{ minHeight: minHeight || '56px' }}
            className="w-full flex flex-wrap justify-center gap-4 py-2"
          >
            <AnimatePresence mode="popLayout">
              {categories.map(category => (
                <motion.button
                  key={category.id}
                  layout
                  variants={buttonVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  transition={{ layout: { duration: 0.32, ease: [0.4, 0, 0.2, 1] } }}
                  className={`flex-1 min-w-[108px] max-w-[162px] px-6 py-2 rounded-full overflow-hidden font-semibold text-base shadow transition-all duration-300 whitespace-nowrap border-2 focus:outline-none focus:ring-2 focus:ring-green-400/50 truncate
                    ${
                      selectedCategory === category.id
                        ? 'bg-gradient-to-r from-green-500 to-green-400 text-white border-green-500 scale-105 shadow-lg'
                        : 'bg-white text-gray-700 border-gray-200 hover:bg-green-50 hover:border-green-300 active:scale-95'
                    }
                  `}
                  onClick={() => onSelect(category.id)}
                  style={{
                    flexBasis: '0',
                    flexGrow: 1,
                    transition: 'all 0.3s cubic-bezier(.4,0,.2,1)',
                  }}
                >
                  <span className="truncate block w-full text-ellipsis whitespace-nowrap">
                    {category.name}
                  </span>
                </motion.button>
              ))}
            </AnimatePresence>
          </motion.div>
        )}
      </AnimatePresence>
    );
  }
  // Klasik (animasyonsuz) hali
  return (
    <div className="w-full flex flex-wrap justify-center gap-4 py-2">
      {categories.map(category => (
        <button
          key={category.id}
          className={`flex-1 min-w-[108px] max-w-[162px] px-6 py-2 rounded-full overflow-hidden font-semibold text-base shadow transition-all duration-300 whitespace-nowrap border-2 focus:outline-none focus:ring-2 focus:ring-green-400/50 truncate
            ${
              selectedCategory === category.id
                ? 'bg-gradient-to-r from-green-500 to-green-400 text-white border-green-500 scale-105 shadow-lg'
                : 'bg-white text-gray-700 border-gray-200 hover:bg-green-50 hover:border-green-300 active:scale-95'
            }
          `}
          onClick={() => onSelect(category.id)}
          style={{ flexBasis: '0', flexGrow: 1, transition: 'all 0.3s cubic-bezier(.4,0,.2,1)' }}
        >
          <span className="truncate block w-full text-ellipsis whitespace-nowrap">
            {category.name}
          </span>
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;
